export default "__VITE_ASSET__oXC7Eo3i__"